"use client";

import { ContainerXL } from "@/common";
import NavigationLink from "@/common/navigation-link.common";
import useToast from "@/hooks/useToast";
import { usePathname } from "@/i18n/navigation";
import { LogOut } from "lucide-react";
import { useTranslations } from "next-intl";
import { useParams, useRouter } from "next/navigation";
import Typography from "@mui/material/Typography";

export const LogoutHeader = () => {
  const t = useTranslations();
  const translate = useTranslations("Header");
  const { showToast } = useToast();
  const { locale } = useParams();
  const router = useRouter();
  const isLoggedIn = true;
  const pathname = usePathname();
  const logout = () => {
    localStorage.clear();
    showToast({
      type: "success",
      message: "Logged out!",
    });
    router.push(`/${locale}/login`);
  };
  return (
    <header className="sticky top-0 z-50 border-b border-gray-200 bg-[#1B5E20]">
      <ContainerXL>
        <div className="text-white flex justify-between items-center py-3">
          <div className="flex gap-3 align-center items-center">
          <NavigationLink href="/">
            <img
              src="/District Nagpur.png"
              alt={t("Forest Logo")}
              width={90}
              height={90}
              className="rounded-sm"
            />
          </NavigationLink>
          <NavigationLink href="/">
            <Typography
              sx={{
                fontSize: "1.5rem",
                color: "white",
              }}
            >
              {translate("headerText")}
            </Typography>
          </NavigationLink>
            </div>
          <div className="flex items-center gap-2 hover:cursor-pointer">
            <LogOut />
            <button onClick={logout} className="hover:cursor-pointer">
              {t("Logout")}
            </button>
          </div>
        </div>
      </ContainerXL>
    </header>
  );
};
export default LogoutHeader;
